import { render, staticRenderFns } from "./RadioButtonFacetGroup.vue?vue&type=template&id=325885f9&scoped=true"
import script from "./RadioButtonFacetGroup.vue?vue&type=script&lang=ts"
export * from "./RadioButtonFacetGroup.vue?vue&type=script&lang=ts"
import style0 from "./RadioButtonFacetGroup.vue?vue&type=style&index=0&id=325885f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325885f9",
  null
  
)

export default component.exports